export * from './YfmHeadingSpecs/const';
export {HeadingAction} from '../../markdown/Heading/const';
